const YEAR_MONTH_DAY_PATTERN = 'dd/MM/yy';

const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;

export { MILLISECONDS_PER_DAY, YEAR_MONTH_DAY_PATTERN };
